import { jsx } from "react/jsx-runtime";
import { Drawer as MUIDrawer } from "@mui/material";
import { forwardRef } from "react";
const DrawerInner = ({ ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    MUIDrawer,
    {
      ...restProps,
      ref
    }
  );
};
const Drawer = forwardRef(DrawerInner);
export {
  Drawer
};
